import React from 'react';

interface FootballIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const FootballIcon: React.FC<FootballIconProps> = ({
  className = '',
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.1514 7.14546C10.8006 6.89051 
      10.3254 6.89074 9.97484 7.14603L7.70298 
      8.80039C7.35315 9.05513 7.20687 9.506 
      7.34052 9.9176L8.20629 12.584C8.34011 
      12.9961 8.72411 13.2752 9.15741 13.2752H11.9696C12.4023 
      13.2752 12.786 12.9968 12.9202 12.5855L13.7906 
      9.91908C13.9252 9.5068 13.7787 9.05478 13.4279 8.79982L11.1514 7.14546Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 
      17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 
      6.47715 22 12ZM13.898 19.7735C13.2896 19.9215 12.654 
      20 12 20C10.6339 20 9.34785 19.6576 8.22287 19.054L8.41074 
      18.9172C8.76042 18.6625 8.90673 18.2119 8.77335 17.8004L7.90688 
      15.1273C7.77322 14.7149 7.38909 14.4356 6.9556 14.4356H4.37752C4.13234 
      13.6676 4 12.8493 4 12C4 11.3729 4.07216 10.7626 4.20862 10.1771L5.31153 9.37557C5.66236 9.12061 5.80886 
      8.66858 5.67428 8.25631L5.41363 7.45781C6.32491 6.13892 7.62212 5.10712 9.14206 
      4.5256L9.97592 5.13112C10.326 5.38536 10.7999 5.38559 11.1503 5.13168L12.6734 
      4.02794C14.0618 4.14365 15.3496 4.61395 16.4457 5.34802C16.3969 5.42178 16.3573 
      5.50286 16.3289 5.5899L15.4583 8.25701C15.3238 8.66895 15.47 9.12062 15.8203 
      9.3757L18.0912 11.0294C18.4417 11.2846 18.9169 11.2849 19.2677 11.0299L19.8758 
      10.588C19.9574 11.0464 20 11.5182 20 12C20 13.7673 19.4269 15.4008 18.4565 
      16.7247L17.9387 15.1273C17.805 14.7149 17.4209 14.4356 16.9874 14.4356H14.1772C13.7437 
      14.4356 13.3596 14.7149 13.2259 15.1273L12.3595 17.8004C12.2261 18.2119 12.3724 18.6625 
      12.7221 18.9172L13.898 19.7735Z"
      fill={color}
    />
  </svg>
);

export default FootballIcon;
